<template>
  <main class="mdl-layout__content">
    <div class="page-content">
      <h1 class="mdl-typography--headline">Avdeling</h1>
        <form action="#">
          <h2 class="mdl-typography--title">
            <span v-if="department.id" v-text="'ID ' + department.id"></span>
            <span v-else>Ny</span>
          </h2>
          <div class="contact-info mdl-shadow--2dp">
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <input autocomplete="off" v-model="department.name" class="mdl-textfield__input" type="text" id="sample1">
              <label class="mdl-textfield__label" for="sample1">Navn</label>
            </div>
            <div class="v-error" v-if="errors.name" v-text="errors.name"></div>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <input autocomplete="off" v-model="department.slug" class="mdl-textfield__input" type="text" id="sample2">
              <label class="mdl-textfield__label" for="sample2">Slug</label>
            </div>
            <div class="v-error" v-if="errors.slug" v-text="errors.slug"></div>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <input autocomplete="off" v-model="department.email" class="mdl-textfield__input" type="text" id="sample3">
              <label class="mdl-textfield__label" for="sample3">Epost</label>
            </div>
            <div class="v-error" v-if="errors.email" v-text="errors.email"></div>
          </div>
        </form>
    </div>
    <div class="tab-bar">
      <router-link class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored-grey" :to="{name: 'editor'}">Avbryt</router-link>
      <!--
      <button :disabled="$root.ui.isLoading('department')" @click="deleteDepartment()" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored-red">Delete</button>
      <button @click="previous()" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored-grey">Avbryt</button>
      -->
      <button :disabled="$root.ui.isLoading('department')" @click="saveDepartment()" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored-green">Save</button>
    </div>
  </main>
</template>

<script>
  import mdlFix from '../mixins/mdlFix.js'
  import utils from '../mixins/utils.js'

  export default {
    data () {
      return {
        is_validated: false,
        department: {
            name: null,
            slug: null,
            email: null
        }
      }
    },
    mixins: [mdlFix],
    computed: {
      errors: function(){
        if(this.is_validated){
          var e = {};
            if(!this.department.name)
                e.name = 'Name is required';
            if(!this.department.slug || !this.department.slug.match(/^[a-zA-Z0-9_\-]+$/ig))
                e.slug = 'Please enter valid slug. Valid symbols: a-zA-Z0-9_-';
            if(!this.department.email || !this.department.email.match(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/ig))
                e.email = 'Gyldig e-post må fylles ut';
          return e;
        }else{
          return {};
        }
      }
    },
    methods: {
        getDepartment(){
            var self = this
            if(!self.$route.params.id)
                return;
            self.$root.ui.loading.push('department');
            return self.$store.dispatch('getDepartment', self.$route.params.id).then(function(department){
                console.log(department)
                self.$root.ui.stopLoading('department');
                if(department)
                    self.department = department
            })
        },
        saveDepartment(){
            let self = this;
            if(!self.isValid())
                return;

            self.$root.ui.loading.push('department')
            return self.$store.dispatch('sendDepartment', self.department).then(function (data) {
                self.$root.ui.stopLoading('department')
                if(data)
                  self.$router.push('/editor');
            })
        },
        /*
        deleteDepartment(){
            let self = this;
            self.$dialog.confirm('<div style="font-size:22px">Delete department</div>', {
                cancelText: 'Avbryt',
                okText: 'Ja',
                backdropClose: true,
                html: true
            }).then(function () {
                self.$root.ui.loading.push('department')
                return self.$store.dispatch('deleteDepartment', self.department.id).then(function (data) {
                    self.$root.ui.stopLoading('department')
                    if(data)
                        self.$router.push('/editor');
                })
            })
        },
        */
        isValid: function(){
            this.is_validated = true;
            return !(Object.keys(this.errors).length);
        },
    },
    created(){
        console.log('created');
        if(this.$route.params.id)
            this.getDepartment()
    },
    beforeRouteUpdate: function(to, from, next){
        next()//vm => {}
        if(to.params.id)
            this.getDepartment()
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            console.log('routeEnter');
            if( !(vm.$root.isEuropcarAdmin() || vm.$root.isAdministrator()) )
              vm.$router.push({name: 'reports'})
        })
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// EditorDepartment.vue?07b5eb1a